import React from "react";

import styled from "styled-components/macro";

import {useRecurringGifts} from "../../RecurringGiftsContext";

export default function NotificationMsg() {
  const { state } = useRecurringGifts();

  const {
    status,
    paymentType,
    failedPaymentsCount,
    ID,
    amount,
    userCanEditPaymentMethods,
  } = state.editModal.currentGift;
  const paymentNoun = paymentType?.toLowerCase() || "payment";

  const getCatchupPaymentUrl = () => {
    const location = window.location;
    const fundID = state.editModal.giftDetails?.fund?.ID;

    return `${location.origin}/give/${fundID}?&amount=${amount}`;
  };

  const getContent = () => {
    if (status === "paused") {
      return `This ${paymentNoun} is currently paused.`;
    } else if (status === "expired") {
      return (
        <span>
          This {paymentNoun} has reached its end date. To resume the{" "}
          {paymentNoun},{" "}
          {userCanEditPaymentMethods
            ? "use the Edit button to update or remove the end date"
            : `please have the ${paymentNoun} owner edit or remove the end date`}
          .
        </span>
      );
    } else if (status === "stopped") {
      return (
        <span>
          This {paymentNoun} has been stopped due to a failed
          attempt. To restart the {paymentNoun},{" "}
          {userCanEditPaymentMethods
            ? "please update the payment method"
            : `please have the ${paymentNoun} owner update the payment method`}
          .
        </span>
      );
    } else if (failedPaymentsCount > 0) {
      return (
        <FailedDonationMsg>
          Note: the most recent {paymentNoun} attempt failed. Please{" "}
          {userCanEditPaymentMethods
            ? "verify your payment method"
            : `please have the ${paymentNoun} owner verify the payment method`}
          .
          <br />
          <br />
          Want to make a{" "}
          <a href={getCatchupPaymentUrl()} target="_blank" rel="noreferrer">
            one time catch-up payment
          </a>
          ?
        </FailedDonationMsg>
      );
    } else {
      return null;
    }
  };

  const content = getContent();

  if (!content) return null;

  return <Wrapper>{content}</Wrapper>;
}

const Wrapper = styled.div`
  background-color: #f7f0b6;
  color: #ad8114;
  font-weight: 400;
  padding: 10px 14px;
  border-radius: 10px;
  margin-bottom: 20px;
`;

const FailedDonationMsg = styled.span`
  line-height: 1.4;
  a {
    text-decoration: underline !important;
  }
`;
